// The ringing you hear while an outgoing call is connecting.
//
// Calls are placed with answerOnBridge, so the caller only hears a ring if the
// far network sends one as early media, and many (international ones
// especially) send silence until someone picks up. This plays the familiar
// double ring (400 + 450 Hz: ring 0.4s, gap 0.2s, ring 0.4s, pause 2s)
// in the browser instead. It is generated with Web Audio, so there is no
// sound file to load, and it never goes down the phone line.
//
//   const stop = startRingback();   // when the call starts
//   stop();                          // answered, ended, or the network's own ring arrived

const CYCLE = 3;                       // seconds per ring-ring-pause
const BURSTS = [[0, 0.4], [0.6, 1.0]]; // on/off times within a cycle
const VOLUME = 0.09;

let ctx = null;
function audio() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx || ctx.state === 'closed') ctx = new AC();
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

export function startRingback() {
  let ac;
  try { ac = audio(); } catch { ac = null; }
  if (!ac) return () => {};

  const out = ac.createGain();
  out.gain.value = 0;
  out.connect(ac.destination);
  const oscs = [400, 450].map((f) => {
    const o = ac.createOscillator();
    o.type = 'sine';
    o.frequency.value = f;
    o.connect(out);
    o.start();
    return o;
  });

  // Schedule the on/off pattern a few cycles ahead, topping up as it plays.
  let scheduledTo = ac.currentTime + 0.05;
  const schedule = () => {
    while (scheduledTo < ac.currentTime + CYCLE * 2) {
      BURSTS.forEach(([on, off]) => {
        const a = scheduledTo + on, b = scheduledTo + off;
        out.gain.setValueAtTime(0, a);
        out.gain.linearRampToValueAtTime(VOLUME, a + 0.01);
        out.gain.setValueAtTime(VOLUME, b - 0.01);
        out.gain.linearRampToValueAtTime(0, b);
      });
      scheduledTo += CYCLE;
    }
  };
  schedule();
  const timer = setInterval(schedule, 1000);

  let stopped = false;
  return () => {
    if (stopped) return;
    stopped = true;
    clearInterval(timer);
    try {
      const now = ac.currentTime;
      out.gain.cancelScheduledValues(now);
      out.gain.setValueAtTime(0, now);
      oscs.forEach((o) => o.stop(now + 0.05));
      setTimeout(() => out.disconnect(), 200);
    } catch { /* context already gone */ }
  };
}
